import type { propsInterface as sCardsRatedWrapper } from '~~/modules/design-system/sections/s-cards-rated/s-cards-rated-wrapper.vue'
import type { schemaType as CottagesListType } from '~~/shared/api/rurality/v3/cottages/list/schema'
import type { schemaType as StrapiHomeSchemaType } from '~~/shared/api/strapi/home/schema'
import type { schemaType as StrapiEscapadasDetailSchemaType } from '~~/shared/api/strapi/escapadas/detail/schema'
import type { schemaType as StrapiCottagesPagechemaType } from '~~/shared/api/strapi/cottages-page/schema'
import type { propsInterface as sCardsRatedProps } from '~~/modules/design-system/sections/s-cards-rated/index.vue'
import { useToSCardsRated } from '~/composables/transformers/useToSCardsRated'

export const useToSCardsRatedWrapper = () => {
  const fromStrapiHome = (
    cottage: StrapiHomeSchemaType['attributes']['featured_cottages'][number],
    cottageList: CottagesListType,
  ): sCardsRatedWrapper['items'][number] => {
    const propsReady: sCardsRatedProps =
      useToSCardsRated().fromCottagesListHomeFeatured(cottageList)

    const featuredCottage: sCardsRatedWrapper['items'][number] = {
      title: cottage.title,
      cottages: propsReady,
      button: cottage.button || null,
    }
    return featuredCottage
  }

  const fromStrapiEscapadasDetail = (
    cottage:
      | NonNullable<
          StrapiEscapadasDetailSchemaType['attributes']['featured_cottages']
        >[number]
      | null,
    cottageList: CottagesListType,
  ): sCardsRatedWrapper['items'][number] | null => {
    if (!cottage) return null

    const propsReady: sCardsRatedProps =
      useToSCardsRated().fromCottagesListHomeFeatured(cottageList)

    return {
      title: cottage.title || undefined,
      cottages: propsReady,
      button: cottage.button || null,
    }
  }

  const fromStrapiCottagesPage = (
    cottage:
      | NonNullable<
          StrapiCottagesPagechemaType['attributes']['featured_cottages']
        >[number]
      | null,
    cottageList: CottagesListType,
  ): sCardsRatedWrapper['items'][number] | null => {
    if (!cottage) return null

    const propsReady: sCardsRatedProps =
      useToSCardsRated().fromCottagesListHomeFeatured(cottageList)

    return {
      title: cottage.title || undefined,
      cottages: propsReady,
      button: cottage.button || null,
    }
  }

  return {
    fromStrapiHome,
    fromStrapiEscapadasDetail,
    fromStrapiCottagesPage,
  }
}
